import { TypeStoreDetail } from "@/lib/redux/features/store/type";
import { getPageSizeProducts } from "../category/getPageSizeProducts";

export const gotoHomePage = (router: any, store: TypeStoreDetail) => {
  const countProduct = getPageSizeProducts(store)
  if (countProduct >= (store.count_product || 0)) {
    router.push('/')
  } else {
    router.push('/products/page/1')
  }
}